<icz-object-association-alert [heading]="heading" [associatedObjectClass]="storageUnit?.objectClass ?? ObjectClass.STORAGE_UNIT">
  <ng-container afterHeading>
    @if (!isStorageUnitUnavailable && storageUnit) {
      <a class="p-4" iczLinkWithoutHref (click)="openStorageUnitDetail(storageUnit!)">
        <span class="ref-number">{{ storageUnit.storageUnitNumber }}</span>
      </a>
      <span>({{storageUnit!.name}})</span>
    }
  </ng-container>
</icz-object-association-alert>
